import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-link/node_modules/zen-observable-ts/lib/bundle.esm.js
// module id = 421
// module chunks = 0